module.exports = __webpack_public_path__ + "static/media/right-arrow.deca4796.svg";